import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78b95530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row row-cols-2 g-5" }
const _hoisted_2 = { class: "row row-cols-2 g-5" }
const _hoisted_3 = { class: "row row-cols-2 g-5" }
const _hoisted_4 = { class: "row row-cols-2 g-5" }
const _hoisted_5 = { class: "row row-cols-2 g-5" }
const _hoisted_6 = { class: "row row-cols-2 g-5" }
const _hoisted_7 = { key: 0 }

import { ref, reactive, onMounted } from "vue";
import type { FormInstance } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import EventV2Services from "../../services/EventV2Services";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import ImageUploader from "quill-image-uploader";
import BlotFormatter from "quill-blot-formatter/dist/BlotFormatter";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import { AccessRoles, PointRoles } from "@/core/types/shop/ShopEventRoles";
import UploadImage from "../../../events/components/shop/UploadImage.vue";
import { ConfigSiteTypesSelections } from "@/core/types/SiteTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateNormalEvent',
  props: {
    step: {}
  },
  emits: ["submit"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;




const isSubmitting = ref(false);
const showKeyError = ref(false);
const ruleFormRef = ref<FormInstance>();
const uploadImageRef = ref<any>(null);
const uploadMobileImageRef = ref<any>(null);
const pointItem = ref("all");
const langOptions = ref<any>([]);

const rules = reactive<any>({
  title: [
    { required: true, message: "Please input event title", trigger: "blur" },
  ],
  key: [{ required: true, message: "Please input event key", trigger: "blur" }],
});

const accessRoles = AccessRoles;

const defaultFormData = () => ({
  type: 0,
  name: "",
  accessRoles: ["Client", "Guest", "IB", "Sales"],
  accessSites: [0, 1, 2, 3, 4, 5, 6, 7, 8],
  description: "",
  term: "",
  language: "en-us",
  instruction: {
    pointsRule: { all: "", agent: "", sales: "", client: "" },
  },
  images: {},
});

const formData = ref<any>(defaultFormData());

const reset = () => {
  formData.value = defaultFormData();
  showKeyError.value = false;
};

const uploadImg = async (file: any) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await EventV2Services.uploadImage(fd);
  return res["url"];
};

const getModules = (index: number) => [
  {
    name: "imageUploader" + index,
    module: ImageUploader,
    options: { upload: (file) => uploadImg(file) },
  },
  { name: "blotFormatter" + index, module: BlotFormatter },
];

const submit = async () => {
  if (!ruleFormRef.value) return;
  let isValid = false;
  await ruleFormRef.value.validate((valid) => {
    isValid = valid;
  });
  if (!isValid) return;

  isSubmitting.value = true;
  try {
    formData.value.name = formData.value.title;
    if (formData.value.key.includes(" "))
      formData.value.key = formData.value.key.replace(/\s/g, "-");
    if (!formData.value.applyStartOn)
      formData.value.applyStartOn = new Date().toISOString();
    if (!formData.value.applyEndOn)
      formData.value.applyEndOn = new Date().toISOString();
    if (!formData.value.startOn)
      formData.value.startOn = new Date().toISOString();
    if (!formData.value.endOn) formData.value.endOn = new Date().toISOString();

    await uploadMobileImageRef.value?.uploadImage().then(() => {
      if (uploadMobileImageRef.value?.imageUrls?.length > 0)
        formData.value.images["mobile"] =
          uploadMobileImageRef.value.imageUrls[0];
    });
    await uploadImageRef.value?.uploadImage().then(() => {
      if (uploadImageRef.value?.imageUrls?.length > 0)
        formData.value.images["desktop"] = uploadImageRef.value.imageUrls[0];
    });

    await EventV2Services.createEvent(formData.value);
    MsgPrompt.success("Event created successfully");
    emits("submit");
    reset();
  } catch (error) {
    if (error?.response?.data === "__KEY_ALREADY_EXISTS__")
      showKeyError.value = true;
    MsgPrompt.error(error);
  }
  isSubmitting.value = false;
};

onMounted(() => {
  langOptions.value = LanguageTypes.all;
});

__expose({ submit, reset, isSubmitting, showKeyError });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "ruleFormRef",
    ref: ruleFormRef,
    model: formData.value,
    rules: rules,
    "label-position": "top"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.eventTitle'),
            prop: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.title) = $event)),
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: 
            _ctx.$t('fields.eventKey') +
            ' (Only English letters and numbers, no spaces)'
          ,
            prop: "key"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.key,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.key) = $event)),
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"]),
              (showKeyError.value)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "danger",
                    class: "mt-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Key already exists")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.accessRoles'),
            prop: "accessRoles"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: formData.value.accessRoles,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.accessRoles) = $event)),
                disabled: isSubmitting.value
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accessRoles), (r) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: r.value,
                      label: r.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(r.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.site'),
            prop: "accessSites"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                modelValue: formData.value.accessSites,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.accessSites) = $event)),
                disabled: isSubmitting.value
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigSiteTypesSelections), (s) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: s.value,
                      label: s.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(s.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.applyStartDate')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formData.value.applyStartOn,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.applyStartOn) = $event)),
                type: "datetime",
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.applyEndDate')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formData.value.applyEndOn,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.applyEndOn) = $event)),
                type: "datetime",
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.eventStartDate')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formData.value.startOn,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.startOn) = $event)),
                type: "datetime",
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.eventEndDate')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formData.value.endOn,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.endOn) = $event)),
                type: "datetime",
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('action.uploadDesktopImage')
          }, {
            default: _withCtx(() => [
              _createVNode(UploadImage, {
                ref_key: "uploadImageRef",
                ref: uploadImageRef
              }, null, 512)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('action.uploadMobileImage')
          }, {
            default: _withCtx(() => [
              _createVNode(UploadImage, {
                ref_key: "uploadMobileImageRef",
                ref: uploadMobileImageRef
              }, null, 512)
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ], 512), [
        [_vShow, _ctx.step === 1]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.language')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.language,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.language) = $event)),
                class: "w-200px",
                disabled: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(langOptions.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.code,
                      label: item.code + '   (' + item.name + ')',
                      value: item.code
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.content'),
          prop: "description"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(QuillEditor), {
              theme: "snow",
              content: formData.value.description,
              "onUpdate:content": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.description) = $event)),
              modules: getModules(1),
              contentType: "html",
              toolbar: "full",
              enable: !isSubmitting.value
            }, null, 8, ["content", "modules", "enable"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('title.termsAndConditions'),
          prop: "term"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(QuillEditor), {
              theme: "snow",
              content: formData.value.term,
              "onUpdate:content": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.term) = $event)),
              modules: getModules(2),
              contentType: "html",
              toolbar: "full",
              enable: !isSubmitting.value
            }, null, 8, ["content", "modules", "enable"])
          ]),
          _: 1
        }, 8, ["label"])
      ], 512), [
        [_vShow, _ctx.step === 2]
      ]),
      (_ctx.step === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.pointsRules')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: pointItem.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((pointItem).value = $event)),
                  disabled: isSubmitting.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PointRoles), (r) => {
                      return (_openBlock(), _createBlock(_component_el_radio_button, {
                        key: r.value,
                        label: r.value,
                        onClick: ($event: any) => (pointItem.value = r.value)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(r.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.content')
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(QuillEditor), {
                  theme: "snow",
                  content: formData.value.instruction.pointsRule[pointItem.value],
                  "onUpdate:content": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.instruction.pointsRule[pointItem.value]) = $event)),
                  modules: getModules(3),
                  contentType: "html",
                  toolbar: "full",
                  enable: !isSubmitting.value
                }, null, 8, ["content", "modules", "enable"])
              ]),
              _: 1
            }, 8, ["label"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})